import React from "react";
import PageHero from "../components/shared/PageHero";
import ContactInfoCards from "../components/contact/ContactInfoCards";
import ContactForm from "../components/contact/ContactForm";

export default function Contact() {
  return (
    <>
      <PageHero
        eyebrow="Get In Touch"
        title="We'd Love to Hear From You"
        subtitle="Questions about services, partnerships, or your account? Reach out and our team will get back to you."
      />
      <ContactInfoCards />
      <ContactForm />
    </>
  );
}
